import { createBrowserRouter } from "react-router-dom";
import Home from "../Home/home/Home";
import Main from "../Layout/Main";
import Itcourse from "../Pages/detailspage/itcourse/Itcourse";
import Quiz from "../Pages/detailspage/quiz/Quiz";
import Resale from "../Pages/detailspage/resale/Resale";
import Blogs from "../Pages/blogs/Blogs"

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/itcourse',
                element: <Itcourse></Itcourse>
            },
            {
                path: '/quiz',
                element: <Quiz></Quiz>
            }, {
                path: '/resale',
                element: <Resale></Resale>
            },
            {
                path: '/blog',
                element: <Blogs></Blogs>
            }

        ]
    }
])